import { Row } from "reactstrap";
import VideoTab1 from "./VideoTab1";
import VideoTab2 from "./VideoTab2";
import PagesSort from "../Pages";

const VideoTabs = () => {
  return (
    <Row>
      <VideoTab1 />
      <VideoTab2 />
      <PagesSort pageClass="start" />
    </Row>
  );
};
export default VideoTabs;
